<div class="display-layout-column layout-gap-15">
  <div class="headline">User Settings</div>
  <mat-divider class="headlineDivider"></mat-divider>

  <div class="display-layout-column justify-content-center layout-align-start">
    <div class="display-layout-row layout-gap-10 layout-align-center-center" [formGroup]="searchForm">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input formControlName="filter" matInput (keyup)="applyFilter()" />
        <mat-icon matSuffix>search </mat-icon>
      </mat-form-field>

    </div>
    <button mat-button (click)="openAdd()">
      <mat-icon>add</mat-icon> Add User
    </button>
  </div>

  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>Id</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="Username">
      <th mat-header-cell *matHeaderCellDef>User Name</th>
      <td mat-cell *matCellDef="let element">{{ element.username }}</td>
    </ng-container>

    <ng-container matColumnDef="Firstname">
      <th mat-header-cell *matHeaderCellDef>First Name</th>
      <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
    </ng-container>

    <ng-container matColumnDef="Lastname">
      <th mat-header-cell *matHeaderCellDef>Last Name</th>
      <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
    </ng-container>

    <ng-container matColumnDef="Email">
      <th mat-header-cell *matHeaderCellDef>E-Mail</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>

    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef>Roles</th>
      <td mat-cell *matCellDef="let element">
        @for (role of element.roles; track role) {
          <div>
            {{ role?.name }}
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row; let column; let i = index">
        <button mat-icon-button (click)="deleteColumn(row, i)">
          <mat-icon> delete_outline</mat-icon>
        </button>
        <button mat-icon-button (click)="openEdit(row, i)">
          <mat-icon> edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[10, 20, 25]"
    showFirstLastButtons
  ></mat-paginator>
</div>
